
import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import PageCallToAction from '@/components/PageCallToAction';

const Documentation = () => {
  // Simply redirect back to home instead of attempting to open the documentation
  return <Navigate to="/" replace />;
};

export default Documentation;
